import React, { useCallback } from 'react';

import { getSeverity } from 'pages/item/v2/components/ProtectedData';
import { HistoryOfChangesItem } from 'pages/item/v2/types/history-of-changes';
import isEmpty from 'utils/is-empty';

import ScorePane from '../ScorePane';
import TrendTooltip from '../TrendTooltip';

interface Props {
    cvss3?: {
        cvssV3?: Record<string, string | number>;
    };
}

const Cvss3: React.FC<Props> = ({ cvss3 }) => {
    const getChart = useCallback((data: HistoryOfChangesItem[]) => {
        if (data.every(({ changes }) => 'cvss3' in changes === false)) return null;

        return data.reduce((output, { version, published, changes }) => {
            const score = changes.cvss3?.cvssV3?.baseScore ?? output.at(-1)?.score ?? 0;
            output.push({ version, score, published });
            return output;
        }, [] as { score: number; version: number; published: Date }[]);
    }, []);

    if (!cvss3 || isEmpty(cvss3) || !cvss3.cvssV3 || isEmpty(cvss3.cvssV3)) {
        return null;
    }

    const score = cvss3.cvssV3.baseScore ?? '-1';
    const vector = String(cvss3.cvssV3.vectorString ?? '');

    return (
        <TrendTooltip getChart={getChart} title="CVSS3 score statistics">
            <ScorePane
                score={score}
                severity={getSeverity(score)}
                name="CVSS3"
                vector={vector}
                vectorItems={{
                    attackVector: cvss3.cvssV3.attackVector,
                    attackComplexity: cvss3.cvssV3.attackComplexity,
                    privilegesRequired: cvss3.cvssV3.privilegesRequired,
                    userInteraction: cvss3.cvssV3.userInteraction,
                    scope: cvss3.cvssV3.scope,
                    confidentialityImpact: cvss3.cvssV3.confidentialityImpact,
                    integrityImpact: cvss3.cvssV3.integrityImpact,
                    availabilityImpact: cvss3.cvssV3.availabilityImpact
                }}
            />
        </TrendTooltip>
    );
};

export default Cvss3;
